var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FDA800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7739 16.6672H36.2259C40.7606 16.6672 43.3206 19.2392 43.3339 23.7739V36.2272C43.3339 40.7606 40.7606 43.3339 36.2259 43.3339H23.7739C19.2392 43.3339 16.6672 40.7606 16.6672 36.2272V23.7739C16.6672 19.2392 19.2392 16.6672 23.7739 16.6672ZM30.0659 37.8139C30.6406 37.8139 31.1192 37.3872 31.1726 36.8139V23.2272C31.2259 22.8139 31.0272 22.3992 30.6672 22.1739C30.2926 21.9472 29.8392 21.9472 29.4806 22.1739C29.1192 22.3992 28.9206 22.8139 28.9592 23.2272V36.8139C29.0272 37.3872 29.5059 37.8139 30.0659 37.8139ZM36.2006 37.8139C36.7606 37.8139 37.2392 37.3872 37.3072 36.8139V32.4406C37.3459 32.0126 37.1472 31.6139 36.7859 31.3872C36.4272 31.1606 35.9739 31.1606 35.6006 31.3872C35.2392 31.6139 35.0406 32.0126 35.0939 32.4406V36.8139C35.1472 37.3872 35.6259 37.8139 36.2006 37.8139ZM24.9592 36.8139C24.9059 37.3872 24.4272 37.8139 23.8526 37.8139C23.2792 37.8139 22.7992 37.3872 22.7472 36.8139V27.6006C22.7072 27.1859 22.9059 26.7739 23.2672 26.5472C23.6259 26.3206 24.0806 26.3206 24.4406 26.5472C24.7992 26.7739 25.0006 27.1859 24.9592 27.6006V36.8139Z",
    fill: "#FDA800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon1);
export default __webpack_public_path__ + "static/media/card_icon1.2af1dd259de3a16a97132f40cfe39e5a.svg";
export { ForwardRef as ReactComponent };